// function to act as a class
export function AttachmentLink() { }

// gets called once before the renderer is used
AttachmentLink.prototype.init = function (params) {
    if (!params || !params.data) return;
    this.params = params;
    const that = this.params.context.componentParent;
    if (params.data.rejectionJSON != undefined && params.data.rejectionJSON.rejections[0].rejectionAttachment != undefined) {
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '<a class="ag-cell-link link reject" style="margin-right: 10px"></a>';
        this.attachmentLink = this.eGui.querySelector('.ag-cell-link.reject');
        this.attachmentLink.innerHTML = params.data.rejectionJSON.rejections[0].rejectionAttachment.fileName;
        this.attachmentLinkEventListener = function () {
            params.context.componentParent.downloadFile(params.data.rejectionJSON.rejections[0].rejectionAttachment);
        };
         this.attachmentLink.addEventListener('click', this.attachmentLinkEventListener);
    } else {
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '';
    }
};

// gets called once when grid ready to insert the element
AttachmentLink.prototype.getGui = function () {
    return this.eGui;
};

// gets called whenever the user gets the cell to refresh
AttachmentLink.prototype.refresh = function (params) {
    // return true to tell the grid we refreshed successfully
    return true;
};

// any cleanup we need to be done here
AttachmentLink.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

AttachmentLink.prototype.onClick = function (obj) {
    this.params.onClick(obj);
}